// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"38":"cadb1be3ce8fcf8ed614","979":"c2680abc6b8b962b3aa5"}[chunkId] + ".js";
};